import { Box, Container } from "@mui/material";
import { Helmet } from "react-helmet";
import MotorGrid from "../components/motor/MotorForm";


const MotorScreen = () => {

  return (
    <>
      <Helmet>
        <title>Motor - SOR</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
        }}
      >
        <Container maxWidth={false} sx={{px: 0}}>
            <MotorGrid />
        </Container>
      </Box>
    </>
  );
};

export default MotorScreen;
